import { render, staticRenderFns } from "./ModifyPassword.vue?vue&type=template&id=e25e1224&scoped=true&"
import script from "./ModifyPassword.vue?vue&type=script&lang=js&"
export * from "./ModifyPassword.vue?vue&type=script&lang=js&"
import style0 from "./ModifyPassword.vue?vue&type=style&index=0&id=e25e1224&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e25e1224",
  null
  
)

export default component.exports